import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/extends";
var _excluded = ["position"],
  _excluded2 = ["position"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { View } from '@bubble-ui/primitive-view';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import { defaultComponentTokens } from '../defaultComponentTokens';
import { mapTypographyElement } from '../utils';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
var SlotSide = _ref => {
  var {
    allowTextTruncationAndWrapping,
    children,
    isVisible,
    maxWidth,
    position,
    slotChildrenViewProps,
    slotMinHeight,
    slotViewProps,
    textColorToken,
    textStyleToken,
    topPaddingToTitle
  } = _ref;
  var designContext = useDesignContext(defaultComponentTokens);
  var {
    sideSlotWrapper,
    sideSlotChildrenWrapper
  } = getDefaultStyleSheet({
    allowTextTruncationAndWrapping,
    designContext,
    isVisible,
    maxWidth,
    position,
    slotMinHeight,
    topPaddingToTitle
  });
  return /*#__PURE__*/React.createElement(View, _extends({
    style: sideSlotWrapper
  }, slotViewProps), /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
    context: designContext
  }, /*#__PURE__*/React.createElement(View, _extends({
    style: sideSlotChildrenWrapper
  }, slotChildrenViewProps), React.Children.map(children, child => mapTypographyElement(child, textStyleToken, textColorToken)))));
};
var SlotRight = _ref2 => {
  var {
      position = 'balanced'
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return SlotSide(_objectSpread(_objectSpread({
    position
  }, props), {}, {
    textStyleToken: 'item-information/slot-right-text-style',
    textColorToken: 'item-information/slot-right-text-color'
  }));
};
var SlotLeft = _ref3 => {
  var {
      position = 'balanced'
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded2);
  return SlotSide(_objectSpread(_objectSpread({
    position
  }, props), {}, {
    textStyleToken: 'item-information/slot-left-text-style',
    textColorToken: 'item-information/slot-left-text-color'
  }));
};
SlotRight.displayName = 'ItemInformation.SlotRight';
SlotLeft.displayName = 'ItemInformation.SlotLeft';
export { SlotRight, SlotLeft };
//# sourceMappingURL=SlotSide.js.map